<template>
  <div class="text-center no-data-wrapper relative">
    <aha-icon name="no-result" maintain-color />
    <div class="pt-4 font-bold text-base">
      We couldn't find any results matching  {{ getSearchContent }}
    </div>
    <div
      class="flex justify-center mt-4"
    >
      <div>
        <!-- desktop new presentation button -->
        <aha-button
          class="inline mr-3"
          size="xl"
          @click="onClickNewPresentation"
        >
          <aha-icon
            name="add"
            width="16"
            height="16"
            viewBox="0 0 24 24"
          />
          <span>New Presentation</span>
        </aha-button>
      </div>
      <aha-button
        class="px-2.5 sm:px-4"
        variant="base"
        size="xl"
        @click="request()"
        :disabled="submitting || isComplete"
        :submitting="submitting"
      >
        <span v-if="!isComplete">Request</span>
        <span v-else>Requested</span>
      </aha-button>
    </div>
  </div>
</template>

<script>
import utils from '@/util'
import ApiTemplate from '@/api/template'
import CreateNewPresentationMixin from '@/mixins/presentation/CreateNewPresentationMixin'

export default {
  mixins: [CreateNewPresentationMixin],
  props: {
    keyword: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'template',
    },
  },
  data() {
    return {
      newPresentationTrigger: null,
      isComplete: false,
      submitting: false,
    }
  },
  computed: {
    getSearchContent() {
      if (this.keyword && this.keyword.length > 1) {
        return `"${this.keyword}".`
      }
      return 'this search.'
    },
  },
  methods: {
    onClickNewPresentation() {
      this.newPresentationTrigger = 'New dropdown menu'
      this.createNewPresentation(this.newPresentationTrigger)
    },
    async request() {
      if (this.submitting) return
      this.submitting = true
      try {
        await ApiTemplate.requestTemplate({
          keyword: this.keyword,
          type: this.type,
        })
        utils.showToastSuccess('Thanks for your template request!')
        this.isComplete = true
        this.submitting = false
        this.$emit('request')
        utils.gaTrackEvent(
          'Templates',
          'Templates > Request Template',
          this.keyword,
        )
        const query = {
          from: 'requestTemplate',
        }
        this.$router.push({ name: 'TemplateLibrary', query })
      } catch {
        this.$emit('request')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.no-data-wrapper {
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
</style>
